import { useCallback, useRef } from 'react';

export function useElementMap<
    TKey extends string,
    TElement extends HTMLElement,
>() {
    const elementsRef = useRef(new Map<TKey, TElement>());
    const callbacksRef = useRef(
        new Map<TKey, (element: TElement | null) => void>(),
    );

    const getElement = useCallback((key: TKey) => {
        return elementsRef.current.get(key) ?? null;
    }, []);

    const registerElement = useCallback((key: TKey) => {
        const existing = callbacksRef.current.get(key);
        if (existing) return existing;

        const callback = (element: TElement | null) => {
            if (element) {
                elementsRef.current.set(key, element);
            } else {
                elementsRef.current.delete(key);
            }
        };

        callbacksRef.current.set(key, callback);
        return callback;
    }, []);

    return { getElement, registerElement };
}
